function fn_part_configuration_personalize() {
    var $fn = $(".part_configuration_personalize");

    $fn.on("change", "[data-select-option]", function () {
        $(this).children("option").each(function () {
            var $elm = $(this);
            if ($elm.is(':selected')) {
                var $id = $elm.data("id");
                $fn.find("[data-options-id=" + $id + "] .elm_item_head").trigger("click");
            }
        });
    });

    function fn_part_configuration_personalize_interact() {
        interact('.draggable')
                .draggable({
                    inertia: true,
                    restrict: {
                        restriction: "parent",
                        endOnly: true
                    },
                    autoScroll: false,

                    onmove: dragMoveListener
                });

        function dragMoveListener(event) {
            var target = event.target,
                    x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx / 3,
                    y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy / 3;

            target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
        }
        window.dragMoveListener = dragMoveListener;
    }


    $fn.on("click", "[data-options-id] .elm_item_head", function () {
        var $el = $(this);
        if ($(window).width() > 767) {
            $el.closest("[data-options-id]").siblings(".mod--active").removeClass("mod--active").find(".elm_item_content").slideUp(300);
        } else {
            $el.closest("[data-options-id]").siblings(".mod--active").removeClass("mod--active").find(".elm_item_content").fadeOut(300);
        }
        if (!$el.hasClass("mod--active")) {
            if ($(window).width() > 767) {
                $el.closest("[data-options-id]").addClass("mod--active").find(".elm_item_content").slideDown(300);
            } else {
                $el.closest("[data-options-id]").addClass("mod--active").find(".elm_item_content").fadeIn(300);
            }
            if ($el.closest("[data-options-id]").data("options-id") == "personalize") {
                $fn.find("[data-bike]").closest(".elm_preview").addClass("mod--personalize");
                $fn.find("[data-bike]").find("[data-text-area]").css("opacity", "1");
                if ($("html").hasClass("interact")) {
                    fn_part_configuration_personalize_interact();
                } else {
                    $.getScript("https://cdnjs.cloudflare.com/ajax/libs/interact.js/1.2.8/interact.min.js", function () {
                        fn_part_configuration_personalize_interact();
                        $("html").addClass("interact");
                    });
                }
            } else {
                $fn.find("[data-bike]").closest(".elm_preview").removeClass("mod--personalize");
                $fn.find("[data-bike]").find("[data-text-area]").css("opacity", "0");
                if ($("html").hasClass("interact")) {
                    interact('.draggable').unset();
                }
            }
        }
    });

    $fn.on("input", '[data-personalize-id="name"] [data-text]', function () {
        var $val = $(this).val();
        $fn.find('[data-bike] [data-group="text"] [data-id="personalize"]').text($val);
    });

    $fn.find('[data-personalize-id="name"] [data-font-google]').each(function () {
        $('<link>').appendTo('head').attr({
            type: "text/css",
            rel: "stylesheet",
            href: "https://fonts.googleapis.com/css?family=" + $(this).data("font") + ":400&amp;subset=latin-ext"
        });
    });

    $fn.find('[data-personalize-id="name"] [data-font-local]').each(function () {
        $('<link>').appendTo('head').attr({
            type: "text/css",
            rel: "stylesheet",
            href: "/fonts/" + $(this).data("font").toLowerCase() + "/stylesheet.css"
        });
    });

    // input change
    $(document).on('change', '#configurator-personalize-form :input', function () {
        var $form = $(this).closest('form');

        personalizeRedraw();

        $.ajax({
            method: 'post',
            data: $form.serialize()
        });
    });

    $(document).on('change', '[name="caption[active]"]', function(){
        var elm = $(this);

        if(elm.prop('checked')) {
            $('[name="caption[font]"]').first().parent().click();
        }
    });

    $(document).on('change', '[name="flag[active]"]', function(){
        var elm = $(this);

        if(elm.prop('checked')) {
            $('[name="flag[type]"]').first().parent().click();
        }
    });

    // RAL
    $(document).on('click', '[data-ral-confirm]', function () {
        var $option = $(this).closest('[data-personalize-option]');
        var type = $(this).data('ral-confirm');
        $('[data-ral-value="' + type + '"]').val($('[data-ral-input]').val());
        $('[data-ral-radio="' + type + '"]').prop('checked', true).trigger('change');
        $option.find('[value="matt"]').prop('disabled', false);
        personalizeRedraw();
    });

    function personalizeRedraw() {
        var $form = $('#configurator-personalize-form');

        // flag
        if ($form.find('[data-personalize-id="flag"] [data-personalize-active]').prop('checked')) {
            $form.find('[data-personalize-id="flag"]').find('[data-flag-position]').prop('disabled', false);
            $form.find('[data-personalize-id="flag"]').find('[data-flag]').prop('disabled', false);

            if ($form.find('[data-personalize-id="flag"] [data-flag-position="after"]').prop('checked')) {
                $fn.find('[data-bike] [data-group="text"] [data-flag]').hide().filter('[data-flag="after"]').show();
            } else {
                $fn.find('[data-bike] [data-group="text"] [data-flag]').hide().filter('[data-flag="before"]').show();
            }

            if ($form.find('[data-personalize-id="flag"] [data-flag="circle"]').prop("checked")) {
                $fn.find('[data-bike] [data-group="text"] [data-flag-shape]').hide().filter('[data-flag-shape="circle"]').show();
            } else {
                $fn.find('[data-bike] [data-group="text"] [data-flag-shape]').hide().filter('[data-flag-shape="wide"]').show();
            }
        } else {
            $form.find('[data-personalize-id="flag"]').find('[data-flag-position]').prop('checked', false).prop('disabled', true);
            $form.find('[data-personalize-id="flag"]').find('[data-flag]').prop('checked', false).prop('disabled', true);

            $fn.find('[data-bike] [data-group="text"] [data-flag]').hide().filter('[data-flag="none"]').show();
        }

        // text
        if ($form.find('[data-personalize-id="name"] [data-personalize-active]').prop('checked')) {
            $form.find('[data-personalize-id="name"]').find('[data-text]').prop('disabled', false);
            $form.find('[data-personalize-id="name"]').find('[data-font]').prop('disabled', false);
            $form.find('[data-personalize-id="name"]').find('[data-hex]').prop('disabled', false);

            $fn.find('[data-bike] [data-group="text"] text').css("opacity", "1");

            var $text = $form.find('[data-personalize-id="name"] [data-text]').val();
            $fn.find('[data-bike] [data-group="text"] [data-id="personalize"]').text($text);

            var $font = $form.find('[data-personalize-id="name"] [data-font]:checked').data("font");
            $form.find('[data-personalize-id="name"] [data-text]').css("font-family", $font);
            $fn.find('[data-bike] [data-group="text"] [data-id="personalize"]').css("font-family", $font);
        } else {
            $form.find('[data-personalize-id="name"]').find('[data-text]').prop('disabled', true);
            $form.find('[data-personalize-id="name"]').find('[data-font]').prop('checked', false).prop('disabled', true);
            $form.find('[data-personalize-id="name"]').find('[data-hex]').prop('checked', false).prop('disabled', true);

            $fn.find('[data-bike] [data-group="text"] text').css("opacity", "0");
        }

        $('#configurator-personalize-form').find('[data-options-id]').each(function () {
            var $option = $(this);
            var price = 0;
            var name = [];

            // brutal finish zamezeni matného povrchu
            var $hex = $option.find('[type="radio"][data-hex]:checked');

            if ($hex.data('brutal-finish')) {
                $option.find('[value="matt"]').prop('checked', false).prop('disabled', true);
                $option.find('[value="gloss"]').prop('checked', true);
            } else {
                $option.find('[value="matt"]').prop('disabled', false);
            }

            // odstraneni RAL
            if ($hex.data('brutal-finish') || $hex.data('basic')) {
                $option.find('[data-ral-value]').val('');
            }

            // odstraneni loga
            if ($option.find('[type="radio"][data-remove]:checked').length) {
                $option.find('[data-hex]').prop('checked', false);
            }

            // projde vsechny radio buttony a selectboxy
            $option.find('[type="radio"]:checked, option:selected').each(function () {
                var $elm = $(this);
                var $id = $option.data("options-id");

                // prebarveni kola
                if ($elm.data('hex')) {
                    $fn.find("[data-bike] [data-id=" + $id + "]").css("fill", $elm.data('hex'));
                }

                // schovani loga
                if ($elm.data('remove')) {
                    $fn.find("[data-bike] [data-id=" + $id + "]").fadeOut();
                } else {
                    $fn.find("[data-bike] [data-id=" + $id + "]").fadeIn();
                }

                // vypocet ceny
                price += parseInt($elm.data('price')) || 0;

                // label
                label = $elm.data("label");
                label ? name.push(label) : null;
            });

            // nastaveni ceny a labelu
            $option.find('[data-price] b').text('+' + price);
            $option.find('[data-name] i').text(name.join(' - '));
        });
    }

    // $fn.on({
    //     mouseenter: function () {
    //         var $id = $(this).data("options-id"),
    //                 $group = $("[data-bike] [data-group]");
    //
    //         if ($fn.find($group).filter("[data-group=" + $id + "]").length) {
    //             $fn.find($group).css("opacity", "0.5").filter("[data-group=" + $id + "]").css("opacity", "1");
    //         }
    //         if ($id == "component-1" || $id == "component-2") {
    //             $fn.find($group).css("opacity", "0.5").filter('[data-group="component"]').css("opacity", "1");
    //         }
    //     },
    //     mouseleave: function () {
    //         $fn.find("[data-bike] [data-group]").css("opacity", "1");
    //     }
    // }, "[data-options-id]");

    personalizeRedraw();
}